export default function Design(props: any) {
    return (
        <svg width="44" height="44" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="6.90625" y="19.1406" width="31.997" height="20.8571" rx="1.83776" stroke="#F9F9F9" strokeWidth="2" />
            <rect x="8.5" y="4.5" width="28" height="9" rx="1.83776" stroke="#F9F9F9" strokeWidth="2" />
            <path d="M7.5 32.5H38.5" stroke="#F9F9F9" strokeWidth="2" strokeLinecap="round" />
            <path d="M7.5 26.5H38.5" stroke="#F9F9F9" strokeWidth="2" strokeLinecap="round" />
            <path d="M17.5 13.5V18.5" stroke="#F9F9F9" strokeWidth="2" strokeLinecap="round" />
            <path d="M22.5 13.5V18.5" stroke="#F9F9F9" strokeWidth="2" strokeLinecap="round" />
            <path d="M27.5 13.5V18.5" stroke="#F9F9F9" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );
}
